import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getWordmarkAsset } from "@/constants/assets";
import { ROUTES } from "@/constants/navigation";
import { useTheme } from "@/hooks/useTheme";
import "./HeaderBrand.css";

export function HeaderBrand() {
  const { t } = useTranslation();
  const { theme } = useTheme();

  return (
    <Link to={ROUTES.home} className="site-header__brand">
      <img
        src={getWordmarkAsset(theme)}
        alt={t("brand")}
        className="site-header__logo"
        width={151}
        height={32}
      />
    </Link>
  );
}
